export default "__VITE_ASSET__Bmc7BI$F__"